import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import SEOTags from './components/SEOTags';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategorySection from './components/CategorySection';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ArticleSection from './components/ArticleSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <SEOTags />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategorySection />
        <StatsSection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}